import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { setLanguage } from '@rci/state-common-actions';
import { WindowService } from '@rogers/cdk/common/services';
import { skip, tap } from 'rxjs/operators';

@Injectable()
export class CommonEffects {
  setLanguage = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLanguage),
        tap(({ language }) => this.translateService.use(language)),
      ),
    { dispatch: false },
  );

  toggleVALanguage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLanguage),
        skip(1),
        tap(({ language }) =>
          this.windowSvc.windowRef().postMessage(
            {
              message: 'VA-CHNG-LANG',
              messageData: {
                language,
              },
            },
            '/',
          ),
        ),
      ),
    {
      dispatch: false,
    },
  );
  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private windowSvc: WindowService,
  ) {}
}
